import { sellerApi, adminApi } from "./api";

export const getSellerListApi = async () => {
  const res = await adminApi.get("/api/v1/seller/list");
  return res.data;
};

export const getSellerByIdApi = async (sellerId) => {
  const res = await adminApi.get(`/api/v1/seller/${sellerId}`);
  return res.data;
};

/** @param {string} sellerId - Seller ID */
/** @param {string} status - e.g. "inactive" | "active" */
export const updateSellerStatusApi = async (sellerId, status) => {
  const res = await adminApi.put(`/api/v1/seller/${sellerId}/status`, { status });
  return res.data;
};

export const approveSellerApi = async (sellerId) => {
  const res = await adminApi.put(`/api/v1/seller/${sellerId}/approve`);
  return res.data;
};

export const rejectSellerApi = async (sellerId, rejectReason = "") => {
  const res = await adminApi.put(`/api/v1/seller/${sellerId}/reject`, { rejectReason });
  return res.data;
};

// --- Orders ---
export const getSellerOrdersApi = async () => {
  // Backend: router.get("/seller", auth, roleGuard("seller"), ctrl.getMySellerOrders);
  // Path: /api/v1/orders/seller
  const res = await sellerApi.get("/api/v1/orders/seller");
  return res.data;
};

export const updateOrderStatusApi = async (orderId, status) => {
  // Backend: router.put("/:id/status", auth, roleGuard("admin", "superadmin", "seller"), ctrl.updateOrderStatus);
  // Path: /api/v1/orders/:id/status
  const res = await sellerApi.put(`/api/v1/orders/${orderId}/status`, { status });
  return res.data;
};

export const updateOrderTrackingNumberApi = async (orderId, trackingNumber, vehicleTypeId, note) => {
  // Backend: router.put("/:id/tracking", auth, roleGuard("admin", "superadmin", "seller"), ctrl.updateTrackingNumber);
  // Path: /api/v1/orders/:id/tracking
  const res = await sellerApi.put(`/api/v1/orders/${orderId}/shipping`, {
    trackingNumber,
    shipStatus: "shipped",
    vehicleTypeId,
    note,
  });
  return res.data;
};

export const callRiderApi = async (orderId) => {
  const res = await sellerApi.post(`/api/v1/orders/${orderId}/call-rider`);
  return res.data;
};

export const cancelOrderBySellerApi = async (orderId, cancelReason = "") => {
  const res = await sellerApi.post(`/api/v1/orders/${orderId}/seller-cancel`, { cancelReason });
  return res.data;
};

export const cancelSeekingRiderApi = async (orderId) => {
  const res = await sellerApi.post(`/api/v1/orders/${orderId}/cancel-seeking-rider`);
  return res.data;
};

// --- Products ---
export const getProductCategoriesApi = async () => {
  // Backend: router.get("/category", ...);
  // Path: /api/v1/products/category
  const res = await sellerApi.get("/api/v1/products/category");
  return res.data;
};

export const createSellerProductApi = async (formData) => {
  // Backend: router.post("/add-product", auth, roleGuard("seller"), ctrl.addProduct);
  // Path: /api/v1/products/add-product
  // console.log(formData);

  const res = await sellerApi.post("/api/v1/products/add-product", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};
export const updateSellerProductApi = async (productId, formData) => {
  // Backend: router.post("/add-product", auth, roleGuard("seller"), ctrl.addProduct);
  // Path: /api/v1/products/add-product
  const res = await sellerApi.put(
    `/api/v1/products/update-product/${productId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return res.data;
};

export const updateProductStatusApi = async (productId, status) => {
  const res = await sellerApi.patch(`/api/v1/products/update-product/${productId}/status`, { status });
  return res.data;
};

export const deleteSellerProductApi = async (productId) => {
  // Backend: router.delete("/delete-product/:id", auth, roleGuard("seller"), ctrl.deleteProduct);
  // Path: /api/v1/products/delete-product/:id
  const res = await sellerApi.delete(`/api/v1/products/delete-product/${productId}`);
  return res.data;
};

export const getSellerProductsApi = async (params = {}) => {
  // Backend: router.get("/product-seller", ...);
  // Path: /api/v1/products/product-seller
  const queryParams = {
    search: params.search || "",
    status: params.status || null,
    limit: params.limit || 10,
    offset: params.offset || 0,
  };
  // Remove null/empty values
  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] === null || queryParams[key] === "") {
      delete queryParams[key];
    }
  });
  const res = await sellerApi.get("/api/v1/products/product-seller", {
    params: queryParams,
  });
  return res.data;
};

//get seller product by id
export const getSellerProductByIdApi = async (id) => {
  // Backend: router.get("/product-seller/:id", ...);
  // Path: /api/v1/products/product-seller/:id
  const res = await sellerApi.get(`/api/v1/products/product-id/${id}`);
  return res.data;
};

// --- Admin Withdrawals ---
export const getWithdrawRequestsApi = async (params = {}) => {
  // Backend: router.get("/withdrawals", auth, roleGuard("admin", "superadmin"), ctrl.listWithdrawRequests);
  const res = await adminApi.get("/api/v1/withdrawals", { params });
  return res.data;
};

export const approveWithdrawRequestApi = async (withdrawId) => {
  // Backend: router.post("/:id/approve", auth, roleGuard("admin", "superadmin"), ctrl.approveWithdraw);
  const res = await adminApi.post(`/api/v1/withdrawals/${withdrawId}/approve`);
  return res.data;
};

export const rejectWithdrawRequestApi = async (withdrawId, reason) => {
  // Backend: router.post("/:id/reject", auth, roleGuard("admin", "superadmin"), ctrl.rejectWithdraw);
  const res = await adminApi.post(`/api/v1/withdrawals/${withdrawId}/reject`, {
    reason,
  });
  return res.data;
};

// --- Profile ---
export const getSellerProfileApi = async () => {
  const res = await sellerApi.get("/api/v1/auth/seller/profile");
  return res.data;
};

export const updateSellerProfileApi = async (data) => {
  const res = await sellerApi.put("/api/v1/auth/seller/profile", data);
  return res.data;
};

export const updateSellerProfileImageApi = async (file) => {
  const formData = new FormData();
  formData.append("storeImage", file);
  const res = await sellerApi.put("/api/v1/auth/seller/profile/image", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return res.data;
};

export const updateSellerPasswordApi = async (data) => {
  const res = await sellerApi.put("/api/v1/auth/seller/password", data);
  return res.data;
};

// --- Seller Stats ---
export const getSellerKpiCardsApi = async () => {
  const res = await sellerApi.get("/api/v1/seller/stats/kpi-cards");
  return res.data;
};

export const getSellerOrderStatusSummaryApi = async (params = {}) => {
  const res = await sellerApi.get("/api/v1/seller/stats/order-status-summary", { params });
  return res.data;
};

export const getSellerSalesByPeriodApi = async (params = {}) => {
  const res = await sellerApi.get("/api/v1/seller/stats/sales-by-period", { params });
  return res.data;
};

export const getSellerTopProductsApi = async (params = {}) => {
  const res = await sellerApi.get("/api/v1/seller/stats/top-products", { params });
  return res.data;
};

export const getSellerOrderPendingCountApi = async () => {
  const res = await sellerApi.get("/api/v1/orders/seller/pending-count");
  return res.data;
};

// --- Shipping Config ---
export const getSellerShippingConfigApi = async () => {
  const res = await sellerApi.get("/api/v1/auth/seller/shipping-config");
  return res.data;
};

export const updateSellerShippingConfigApi = async (data) => {
  const res = await sellerApi.put("/api/v1/auth/seller/shipping-config", data);
  return res.data;
};
